(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.stReady === 'true') return;
    root.dataset.stReady = 'true';

    /* ---- Navegación Móvil ---- */
    var burger = root.querySelector('[data-st-burger]');
    var nav = root.querySelector('[data-st-nav]');

    if (burger && nav) {
      var iconPath = burger.querySelector('path');
      var BARS = 'M4 7h16M4 12h16M4 17h16';
      var CLOSE = 'M6 6l12 12M18 6L6 18';

      burger.addEventListener('click', function () {
        var open = nav.dataset.open === 'true';

        nav.dataset.open = String(!open);
        burger.setAttribute('aria-expanded', String(!open));

        if (iconPath) {
          iconPath.setAttribute('d', !open ? CLOSE : BARS);
        }
      });

      nav.addEventListener('click', function (e) {
        if (!e.target.closest('a')) return;

        nav.dataset.open = 'false';
        burger.setAttribute('aria-expanded', 'false');

        if (iconPath) {
          iconPath.setAttribute('d', BARS);
        }
      });
    }

    /* ---- Alineación de Logo ---- */
    function alignLogo() {
      var logo = root.querySelector('[data-m="navlogo"]');
      var title = root.querySelector('[data-m="herotitle"]');

      if (!logo || !title) return;

      if (window.innerWidth <= 900) {
        logo.style.marginLeft = '0px';
        return;
      }

      logo.style.marginLeft = '0px';

      var logoLeft = logo.getBoundingClientRect().left;
      var titleLeft = title.getBoundingClientRect().left;
      var delta = titleLeft - logoLeft;

      logo.style.marginLeft = delta + 'px';
    }

    alignLogo();
    setTimeout(alignLogo, 300);
    window.addEventListener('resize', alignLogo);

    /* ---- Autoplay Videos ---- */
    function kickVideos() {
      root
        .querySelectorAll('video.st-hero__media, video.st-cta__media')
        .forEach(function (video) {
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;

          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');

          if (video.paused) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) {
              playPromise.catch(function () {});
            }
          }
        });
    }

    kickVideos();
    setTimeout(kickVideos, 600);

    ['touchstart', 'click', 'scroll', 'visibilitychange'].forEach(function (eventName) {
      document.addEventListener(eventName, kickVideos, { passive: true });
    });

    /* ---- Integración Carrito Shopify ---- */
    var badge = root.querySelector('[data-st-cart-count]');

    function setCartCount(count) {
      if (!badge) return;

      badge.textContent = String(count || 0);
      badge.dataset.visible = count > 0 ? 'true' : 'false';
    }

    function refreshCartCount() {
      var base =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        '/';

      return fetch(base + 'cart.js', {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('No se pudo obtener el carrito');
          }
          return response.json();
        })
        .then(function (cart) {
          setCartCount(cart.item_count);

          document.dispatchEvent(
            new CustomEvent('storytime:cart-updated', {
              detail: { cart: cart }
            })
          );

          return cart;
        })
        .catch(function (error) {
          console.error('[Storytime cart]', error);
        });
    }

    refreshCartCount();

    /* ---- Tarjetas de Producto ---- */
    root.querySelectorAll('[data-st-card]').forEach(function (card) {
      var quantityOutput = card.querySelector('[data-st-qty]');
      var max = parseInt(card.dataset.stMax || '9', 10);

      var addButton = card.querySelector('[data-st-add]');
      var addLabel = addButton ? addButton.querySelector('[data-st-add-label]') : null;

      var originalLabel = addLabel ? addLabel.textContent.trim() : '';
      var resetTimer;

      /* Selector de Cantidad */
      card.querySelectorAll('[data-st-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!quantityOutput) return;

          var current = parseInt(
            quantityOutput.value || quantityOutput.textContent || '1',
            10
          );

          var step = parseInt(button.dataset.stStep || '0', 10);
          var next = Math.min(max, Math.max(1, current + step));

          quantityOutput.value = next;
          quantityOutput.textContent = next;
        });
      });

      if (!addButton || addButton.disabled) return;

      /* Evento Agregar al Carrito AJAX */
      addButton.addEventListener('click', function () {
        var variantId = parseInt(card.dataset.stVariantId || '0', 10);
        var quantity = parseInt(
          quantityOutput.value || quantityOutput.textContent || '1',
          10
        );

        if (!variantId || quantity < 1) return;

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');

        var base =
          (window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root) ||
          '/';

        fetch(base + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: quantity
              }
            ]
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (body) {
                throw new Error(
                  body.description || 'No se pudo agregar el producto'
                );
              });
            }
            return response.json();
          })
          .then(function () {
            addButton.dataset.added = 'true';

            if (addLabel) {
              addLabel.textContent =
                addButton.dataset.stAddedLabel || '¡Agregado!';
            }

            return refreshCartCount();
          })
          .catch(function (error) {
            console.error('[Storytime cart]', error);

            addButton.dataset.error = 'true';

            if (addLabel) {
              addLabel.textContent =
                addButton.dataset.stErrorLabel || 'Intenta de nuevo';
            }
          })
          .finally(function () {
            clearTimeout(resetTimer);

            resetTimer = setTimeout(function () {
              addButton.dataset.added = 'false';
              addButton.dataset.error = 'false';

              addButton.disabled = false;
              addButton.removeAttribute('aria-busy');

              if (addLabel) {
                addLabel.textContent = originalLabel;
              }
            }, 1800);
          });
      });
    });

    /* ---- Animación de Contador ---- */
    var stats = root.querySelectorAll('[data-st-count]');

    function animateStat(element) {
      var target = parseFloat(element.dataset.stCount);
      if (!isFinite(target)) return;

      var decimals = parseInt(element.dataset.stDecimals || '0', 10);
      var prefix = element.dataset.stPrefix || '';
      var suffix = element.dataset.stSuffix || '';

      if (element.dataset.stSuffixSpace === 'true' && suffix) {
        suffix = ' ' + suffix;
      }

      var duration = parseInt(element.dataset.stDuration || '1400', 10);
      var start = null;

      function frame(now) {
        if (start === null) start = now;

        var progress = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - progress, 3);

        element.textContent =
          prefix + (target * eased).toFixed(decimals) + suffix;

        if (progress < 1) {
          requestAnimationFrame(frame);
        }
      }

      requestAnimationFrame(frame);
    }

    if (stats.length) {
      var reduceMotion =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!('IntersectionObserver' in window) || reduceMotion) {
        stats.forEach(function (element) {
          var staticSuffix = element.dataset.stSuffix || '';
          if (element.dataset.stSuffixSpace === 'true' && staticSuffix) {
            staticSuffix = ' ' + staticSuffix;
          }
          element.textContent =
            (element.dataset.stPrefix || '') +
            element.dataset.stCount +
            staticSuffix;
        });
      } else {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry, index) {
              if (!entry.isIntersecting) return;

              observer.unobserve(entry.target);

              setTimeout(function () {
                animateStat(entry.target);
              }, index * 180);
            });
          },
          { threshold: 0.3 }
        );

        stats.forEach(function (element) {
          element.textContent =
            (element.dataset.stPrefix || '') +
            '0' +
            (element.dataset.stSuffix || '');

          observer.observe(element);
        });
      }
    }
  }

  /* ---- Inicializar ---- */
  function boot(scope) {
    (scope || document)
      .querySelectorAll('[data-st-root]')
      .forEach(function (root) {
        init(root);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  /* Support Shopify Theme Editor */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();